import * as WdsComponents from '@worksome/wds-components'

/**
 * List components you would like to be registered,
 * ideally only the ones you are using in the blade template.
 * This is so that we don't register all of them automatically
 * to keep bundle size smaller
 *
 * e.g. 'WdsButton'
 */
const register = [
  'WdsAccordion',
  'WdsAccordionItem',
  'WdsAlert',
  'WdsAvatar',
  'WdsAvatarLabel',
  'WdsCheckbox',
  'WdsButton',
  'WdsButtonGhost',
  'WdsStack',
  'WdsButtonText',
  'WdsTag',
  'WdsLabel',
  'WdsText',
  'WdsHeading',
  'WdsPageSignup',
  'WdsProgress',
  'WdsIcon',
  'WdsInput',
  'WdsInputArea',
  'WdsIconChevronLeft',
  'WdsIconChevronRight',
  'WdsSelect',
  'WdsSidebar',
  'WdsSidebarHeader',
  'WdsSidebarBody',
  'WdsSidebarFooter',
  'WdsNavigation',
  'WdsNavigationGroup',
  'WdsNavigationCategory',
  'WdsNavigationItem',
  'WdsMenu',
  'WdsMenuOption',
  'WdsMenuDivider',
  'WdsMenuTitle',
  'WdsIcon',
  'WdsButton',
  'WdsLabel',
  'WdsPopover',
  'WdsStack',
  'WdsTooltip',
  'WdsTag',
  'WdsNavigationAccountMenu',
  'WdsDivider',
  'WdsBadge',
  'WdsButtonIcon',
  'WdsSegmentedControl',
  'WdsInputCurrency',
  'WdsRadio',
  'WdsRadioGroup',
  'WdsToggle',
  'WdsModal',
  'WdsProgressBar',
]

export function getWdsComponents() {
  const components = {}
  Object.entries(WdsComponents).forEach(([name, component]) => {
    if (register.includes(name)) {
      components[name] = component
    }
  })
  return components
}

export function loadWdsComponents(app) {
  Object.entries(WdsComponents).forEach(([name, component]) => {
    if (register.includes(name)) {
      app.component(name, component)
    }
  })
}
